import { ApiError } from '@/api/client';
import { serverErrorsOf } from '@/lib/formErrors';
import { notAvailableYet } from '@/lib/mutationError';

/** What an edit form shows after a failed save: per-field messages, a problem alert and/or a toast. */
export interface EditFailure {
  server: Record<string, string>;
  problem: unknown;
  toast?: { title: string; description?: string };
}

/**
 * Maps an API failure for the edit sheets and dialogs: a 501 says the route is not served yet, a 412 tells the user to
 * reopen the form on the reloaded record (`staleMessage`), otherwise the API's per-field messages go under their fields
 * and what names no field becomes the problem alert (or a toast for 5xx and network failures). Kept apart from the
 * models because `ApiError` pulls in the auth client, which needs `window`.
 */
export function editFailureOf(err: unknown, staleMessage: string, slugField = 'slug'): EditFailure {
  const unavailable = notAvailableYet(err);
  if (unavailable) return { server: {}, problem: unavailable };
  if (err instanceof ApiError && err.status === 412) return { server: {}, problem: new ApiError(412, err.code, staleMessage, err.requestId) };
  const mapped = serverErrorsOf(err, slugField);
  const namesNoField = Object.keys(mapped.fields).length === 0;
  const problem = mapped.form ? new Error(mapped.form) : err;
  return { server: mapped.fields, problem: namesNoField ? problem : null, toast: mapped.toast };
}
